export default function SectionHeader({ chapter, label, title, italic, intro, align = "left", accent = "sage" }) {
  const accentColors = {
    sage: "text-sage-600",
    clay: "text-clay-500",
    honey: "text-honey-600",
    ink: "text-ink-900",
  };
  return (
    <div className={`grid lg:grid-cols-12 gap-8 mb-14 ${align === "center" ? "text-center" : ""}`}>
      <div className="lg:col-span-7">
        <div className="flex items-center gap-4">
          {chapter && (
            <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-ink-500">
              §&nbsp;{chapter}
            </span>
          )}
          <span className="h-[1px] w-10 bg-sage-500" />
          <span className={`font-mono-fine text-[11px] tracking-[0.28em] uppercase ${accentColors[accent]}`}>
            {label}
          </span>
        </div>
        <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-[4.25rem] leading-[0.96] tracking-[-0.035em] text-ink-900">
          {title}
          {italic && (
            <>
              <br />
              <span className="italic font-normal">{italic}</span>
            </>
          )}
        </h2>
      </div>
      {intro && (
        <div className="lg:col-span-4 lg:col-start-9 lg:pt-8">
          <p className="text-ink-500 text-[16px] leading-relaxed">{intro}</p>
        </div>
      )}
    </div>
  );
}
